module.exports = __webpack_public_path__ + "img/centrifuge-C-shadow.9f2d05cb.png";